<template>
  <div
    class="px-4 py-3 cursor-pointer transition-all duration-200 text-sm relative select-none group"
    :class="{
      'bg-blue-600 text-white shadow-sm': selected && !focused && !isProtected,
      'bg-blue-700 text-white shadow-md': selected && focused && !isProtected,
      'bg-blue-500 text-white shadow-sm opacity-75': selected && isProtected,
      'bg-main-hover/10 ring-2 ring-main-hover ring-inset': focused && !selected && !isProtected,
      'hover:bg-gray-50 hover:shadow-sm': !selected && !focused && !isProtected,
      'text-gray-900': !selected && !focused && !isProtected,
      'bg-gray-100 text-gray-500 cursor-not-allowed opacity-75': isProtected && !selected,
      'cursor-not-allowed': isProtected && selected
    }"
    @click="handleClick"
    @mouseenter="$emit('focus')"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center flex-1 min-w-0">
        <!-- Content slot -->
        <div class="flex-1 min-w-0">
          <slot>
            <span class="block truncate font-medium text-white" v-if="selected">
              {{ label }}
            </span>
            <span class="block truncate font-medium text-gray-500" v-else-if="isProtected">
              {{ label }}
            </span>
            <span class="block truncate font-medium text-gray-900" v-else>
              {{ label }}
            </span>
          </slot>
        </div>
      </div>
      
      <!-- Additional checkmark for extra emphasis when selected -->
      <div v-if="selected && !isProtected" class="ml-3 flex-shrink-0">
        <div class="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
          <CheckIcon class="h-4 w-4 text-white" />
        </div>
      </div>
      
      <!-- Protected lock icon for selected protected options -->
      <div v-else-if="selected && isProtected" class="ml-3 flex-shrink-0">
        <div class="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
          <LockClosedIcon class="h-4 w-4 text-white" />
        </div>
      </div>
    </div>

    <!-- Focus ring for keyboard navigation -->
    <div 
      v-if="focused && !selected" 
      class="absolute inset-0 border-2 border-main-hover rounded pointer-events-none"
    ></div>
    
    <!-- Selected state glow effect -->
    <div 
      v-if="selected" 
      class="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent pointer-events-none"
    ></div>
  </div>
</template>



<script>
import { CheckIcon, LockClosedIcon } from '@heroicons/vue/24/outline';

export default {
  name: "Option",
  components: {
    CheckIcon,
    LockClosedIcon
  },
  props: {
    value: { type: [String, Number, Object, Boolean, null], required: true },
    label: { type: String, default: "" },
    selected: { type: Boolean, default: false },
    isProtected: { type: Boolean, default: false },
    focused: { type: Boolean, default: false }
  },
  emits: ['select', 'focus'],
  methods: {
    handleClick() {
      // Prevent deselection of protected options
      if (this.isProtected && this.selected) {
        return; // Do nothing if trying to deselect a protected option
      }
      this.$emit('select', this.value);
    }
  }
}
</script>
